"use client";
import { Box, Flex, Heading, Link, Text } from "@chakra-ui/react";
import { PageBlockInstagramDisplay } from "lib/gcms";
import { useEffect } from "react";
import { SectionTemplate } from "./section-template";
import Image from "next/image";
import { InstagramLogo } from "@areahub/icons";

const importScript = (url: string) => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = url;
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, [url]);
};

const InstagramDisplay = ({
  title,
  backgroundColor,
  textColor,
}: PageBlockInstagramDisplay) => {
  importScript("//www.instagram.com/embed.js");
  return (
    <SectionTemplate
      {...{ bg: backgroundColor, color: textColor, from: "news-room" }}
    >
      <Heading
        maxW="48rem"
        mx="auto"
        textAlign="center"
        fontWeight="extrabold"
        size="2xl"
        letterSpacing="tight"
      >
        {title}
      </Heading>
      <Flex
        justifyContent="space-evenly"
        alignItems={{
          base: "center",
          lg: "start",
        }}
        mt={10}
        flexDir={{
          base: "column",
          lg: "row",
        }}
        gap={{
          base: 10,
          lg: 0,
        }}
      >
        <Box>
          <Text
            textAlign="center"
            mb={4}
            fontSize={{
              base: "lg",
              lg: "2xl",
            }}
            fontWeight="bold"
          >
            LinkedIn
          </Text>
          <Box>
            <Link
              href="https://www.linkedin.com/company/myareahub/mycompany/"
              target="_blank"
            >
              <Image
                src="https://media.graphassets.com/JzG9wrPSLmxyPnADM8BF"
                alt="LinkedIn Profile and Post"
                width="300"
                height="300"
              />
            </Link>
          </Box>
        </Box>
        <Box>
          <Text
            textAlign="center"
            mb={4}
            fontSize={{
              lg: "2xl",
            }}
            fontWeight="bold"
          >
            Instagram
          </Text>
          <Box
            as="blockquote"
            className="instagram-media"
            data-instgrm-permalink="https://www.instagram.com/myareahub/?utm_source=ig_embed&amp;utm_campaign=loading"
            data-instgrm-version="14"
            background="#FFF"
            border="0"
            borderRadius="10px"
            boxShadow="0 0 1px 0 rgba(0,0,0,0.5),0 1px 10px 0 rgba(0,0,0,0.15)"
            padding="0"
            w={{
              base: "300px",
              lg: "400px",
            }}
          >
            <Box padding="16px">
              <Link
                href="https://www.instagram.com/myareahub/?utm_source=ig_embed&amp;utm_campaign=loading"
                background="#FFFFFF"
                lineHeight="0"
                padding="0 0"
                textAlign="center"
                textDecoration="none"
                width="100%"
                target="_blank"
              >
                <Box display=" flex" flexDirection="row" alignItems="center">
                  <Box
                    backgroundColor="#F4F4F4"
                    borderRadius="50%"
                    flexGrow={0}
                    height="40px"
                    marginRight="14px"
                    width="40px"
                  />
                  <Box
                    display="flex"
                    flexDirection="column"
                    flexGrow="1"
                    justifyContent="center"
                  >
                    <Box
                      backgroundColor="#F4F4F4"
                      borderRadius="4px"
                      flexGrow="0"
                      height="14px"
                      marginBottom="6px"
                      width="100px"
                    />
                    <Box
                      backgroundColor="#F4F4F4"
                      borderRadius="4px"
                      flexGrow="0"
                      height="14px"
                      width=" 60px"
                    />
                  </Box>
                </Box>
                <Box padding="19% 0" />
                <Box
                  display="block"
                  height="50px"
                  margin="0 auto 12px"
                  width="50px"
                >
                  <InstagramLogo />
                </Box>
                <Box paddingTop="8px">
                  <Box
                    color="red"
                    fontFamily="Arial,sans-serif"
                    fontSize="14px"
                    fontStyle="normal"
                    fontWeight="550"
                    line-height="18px"
                  >
                    View this profile on Instagram
                  </Box>
                </Box>
                <Box padding="12.5% 0"></Box>{" "}
                <Box
                  display="flex"
                  flexDirection="row"
                  marginBottom="14px"
                  alignItems="center"
                >
                  <Box>
                    <Box
                      backgroundColor="#F4F4F4"
                      borderRadius="50%"
                      height="12.5px"
                      width="12.5px"
                      transform="translateX(0px) translateY(7px)"
                    />
                    <Box
                      backgroundColor="#F4F4F4"
                      height="12.5px"
                      transform="rotate(-45deg) translateX(3px) translateY(1px)"
                      width="12.5px"
                      flexGrow="0"
                      marginRight="14px"
                      marginLeft="2px"
                    />
                    <Box
                      backgroundColor="#F4F4F4"
                      borderRadius="50%"
                      height="12.5px"
                      width="12.5px"
                      transform="translateX(9px) translateY(-18px)"
                    />
                  </Box>
                  <Box marginLeft="8px">
                    <Box
                      backgroundColor="#F4F4F4"
                      borderRadius="50%"
                      flexGrow="0"
                      height="20px"
                      width="20px"
                    />
                    <Box
                      width="0"
                      height="0"
                      borderTop="2px solid transparent"
                      borderLeft="6px solid #f4f4f4"
                      borderBottom="2px solid transparent"
                      transform="translateX(16px) translateY(-4px) rotate(30deg)"
                    />
                  </Box>
                  <Box marginLeft="auto">
                    <Box
                      width="0px"
                      borderTop="8px solid #F4F4F4"
                      borderRight="8px solid transparent"
                      transform="translateY(16px)"
                    />
                    <Box
                      backgroundColor="#F4F4F4"
                      flexGrow="0"
                      height="12px"
                      width="16px"
                      transform="translateY(-4px)"
                    />
                    <Box
                      width="0"
                      height="0"
                      borderTop="8px solid #F4F4F4"
                      borderLeft="8px solid transparent"
                      transform="translateY(-4px) translateX(8px)"
                    />
                  </Box>
                </Box>
                <Box
                  display="flex"
                  flexDirection="column"
                  flexGrow="1"
                  justifyContent="center"
                  marginBottom="24px"
                >
                  <Box
                    backgroundColor="#F4F4F4"
                    borderRadius="4px"
                    flexGrow="0"
                    height="14px"
                    marginBottom="6px"
                    width="224px"
                  />
                  <Box
                    backgroundColor="#F4F4F4"
                    borderRadius="4px"
                    flexGrow="0"
                    height="14px"
                    width="144px"
                  />
                </Box>
              </Link>
              <Text
                color="#c9c8cd"
                fontFamily="Arial,sans-serif"
                fontSize="14px"
                lineHeight="17px"
                marginBottom="0"
                marginTop="8px"
                overflow="hidden"
                padding="8px 0 7px"
                textAlign="center"
                textOverflow="ellipsis"
                whiteSpace="nowrap"
              >
                <Link
                  href="https://www.instagram.com/myareahub/?utm_source=ig_embed&amp;utm_campaign=loading"
                  color="#c9c8cd"
                  fontFamily="Arial,sans-serif"
                  fontSize="14px"
                  fontStyle="normal"
                  fontWeight="normal"
                  lineHeight="17px"
                  target="_blank"
                >
                  AreaHub |Climate &amp; Environment
                </Link>{" "}
                (@
                <Link
                  href="https://www.instagram.com/myareahub/?utm_source=ig_embed&amp;utm_campaign=loading"
                  color="#c9c8cd"
                  fontFamily="Arial,sans-serif"
                  fontSize="14px"
                  fontStyle="normal"
                  fontWeight="normal"
                  lineHeight="17px"
                  target="_blank"
                >
                  myareahub
                </Link>
                ) • Instagram photos and videos
              </Text>
            </Box>
          </Box>
        </Box>
      </Flex>
    </SectionTemplate>
  );
};

export default InstagramDisplay;
